export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-transparent dark:border-slate-800 bg-primary dark:bg-slate-900/50 transition-colors duration-300">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-white/90 dark:text-slate-400 text-sm">
            <span>© {currentYear} Javier Callico</span>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://github.com/JCallico/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 dark:text-slate-400 hover:text-white dark:hover:text-slate-100 text-sm transition-colors"
            >
              GitHub
            </a>
            <a
              href="https://x.com/jcallico"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 dark:text-slate-400 hover:text-white dark:hover:text-slate-100 text-sm transition-colors"
            >
              X
            </a>
            <a
              href="https://www.linkedin.com/in/jcallico/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 dark:text-slate-400 hover:text-white dark:hover:text-slate-100 text-sm transition-colors"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
